// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"FiveStarRating_col-md-4___HgwI","mRatingWidget":"FiveStarRating_mRatingWidget__DmZh_","aRating":"FiveStarRating_aRating__jBWmf"};